import { Routes } from './router';
import { QueryProvider } from './service/query-provider';
import './index.css';

import { Toaster } from 'sonner';
import * as Sentry from '@sentry/react';

const ALLOWED_USER_IDS = [728567873, 2234331, 33248754, 1414935306, 6755296119, 1745399285, 5826463868];

function useAccessGuard() {
  if (import.meta.env.DEV) {
    return true;
  }

  const telegramWebApp = window.Telegram?.WebApp;
  const tgUser = telegramWebApp?.initDataUnsafe?.user;

  const isTestBot = import.meta.env.VITE_TEST_BOT_MODE === 'true';

  return Boolean(
    telegramWebApp?.initData &&
      tgUser &&
      (!isTestBot || ALLOWED_USER_IDS.includes(tgUser.id)),
  );
}

function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-white">
      <h2 className="text-xl font-bold mb-2 text-gray-800">Доступ закрыт</h2>
      <p className="text-gray-500">У вас нет доступа к этому приложению.</p>
    </div>
  )
}

function App() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: 1,
    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
  });

  const hasAccess = useAccessGuard();

  if (!hasAccess) {
    return <AccessDenied />;
  }

  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <h2 className="text-xl font-bold mb-4">Something went wrong</h2>
          <p className="text-gray-600 mb-4">
            An error occurred and has been reported.
          </p>
          <button
            onClick={resetError}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Try again
          </button>
        </div>
      )}
    >
      <QueryProvider>
        <Routes />
        <Toaster />
      </QueryProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
